import angular from 'angular';
import { groupBy, sortBy } from 'lodash';

module.exports = angular.module('common.services.accounting-buckets-by-kind', [
])
.factory('accountingBucketsByKind', function(allAvailableAccounts) {
  let sortedAccountingBuckets = sortBy(allAvailableAccounts, 'account');
  let groupedAccountingBuckets = groupBy(sortedAccountingBuckets, acc => acc.account.split('.')[0]);
  return groupedAccountingBuckets;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/accounting-buckets-by-kind.js
 **/